export default {
  charities: [],
  activeCharityInfo: null,
}
